import { render, staticRenderFns } from "./Rechazo.vue?vue&type=template&id=7d15d024&"
import script from "./Rechazo.vue?vue&type=script&lang=js&"
export * from "./Rechazo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports